import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminNav.css';

export default function AdminNav() {
  return (
    <nav className="admin-nav" aria-label="Admin sections">
      <div className="admin-nav-inner">
        <span className="admin-nav-label">Admin</span>
        <div className="admin-nav-links">
          <NavLink to="/admin" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Catalog &amp; jewels
          </NavLink>
          <NavLink to="/admin/enquiries" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Enquiries
          </NavLink>
          <NavLink to="/admin/billing" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Billing
          </NavLink>
        </div>
      </div>
    </nav>
  );
}
